module.exports = __webpack_public_path__ + "static/media/8OLA29.9dcc5120.jpg";